import RequestAbstract from "../abstract";

export default class PayinEvents extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/payin-events";
    }

}
